// NAV PAGES
const getStrapiContentBase = (state) => state.strapiContent;
export const getHomePageData = (state) => getStrapiContentBase(state).home.data;
export const getPlayhubPageData = (state) =>
    getStrapiContentBase(state).playhub.data;
export const getLearnPageData = (state) =>
    getStrapiContentBase(state).learn.data;
export const getWatchPageData = (state) =>
    getStrapiContentBase(state).watch.data;

// ARTICLES
export const getAllArticlesSelector = (state) =>
    getStrapiContentBase(state).articles.allArticles.data;
export const getSingleArticleSelector = (state) =>
    getStrapiContentBase(state).articles.singleArticle.data;
export const getMostViewedArticleSelector = (state) =>
    getStrapiContentBase(state).articles.allArticles.mostViewed;

// VIDEOS
export const getAllVideosSelector = (state) =>
    getStrapiContentBase(state).videos.allVideos.data;
export const getSingleVideoSelector = (state) =>
    getStrapiContentBase(state).videos.singleVideo.data;

// VIDEO CATEGORY
export const getDocumentariesSelector = (state) =>
    getStrapiContentBase(state).videoCategory.documentaries.data;
export const getInterviewsSelector = (state) =>
    getStrapiContentBase(state).videoCategory.interviews.data;
export const getJourneysSelector = (state) =>
    getStrapiContentBase(state).videoCategory.chessJourneys.data;
